import styled from "styled-components";
import { ThemeProp } from "styles/theme";
import { alphalize } from "utils/colors";
import { datasetsMenuFonts } from "styles/font-sizes";

export const StyledWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  font-size: 14px;
  padding: 3px 10px 3px 25px;
  transition-duration: 0s;
  opacity: 0.7;

  :hover {
    opacity: 1;

    .dataset-item-title {
      text-decoration: underline;
    }
  }

  :hover,
  &.open {
    background: ${({ theme }: ThemeProp) => alphalize(theme.textInLight, 0.1)};
  }
`;

export const StyledName = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin-left: 5px;
  font-size: ${datasetsMenuFonts.datasetName}px;
`;
